export default __webpack_public_path__ + "static/media/scholar_7.5199a881.jpg";